import Link from "./Link.jsx";
import { Link as RouterLink } from 'react-router-dom';
import { forwardRef } from "react";

const routerLink = forwardRef(({ children, ...otherProps }, ref) => {
  return <Link component={RouterLink} {...otherProps}>{children}</Link>;
});

export default routerLink